<div class="loader" *ngIf="loading">
  <mat-spinner [diameter]="150"></mat-spinner>
</div>
<div class="card">
  <div class="container">
    <div class="background">
      <div data-test="imagem-recuperacao" class="image">
        <div class="fundo-content">
          <img class="fundo-logo" [src]="appConfig.logoUrl" [alt]="appConfig.appName">
          <h2 class="fundo-title">{{ 'signIn.tagline' | translate }}</h2>
          <p class="fundo-description">{{ 'signIn.taglineDescription' | translate }}</p>
        </div>
      </div>
    </div>
    <div class="mobile-header">
      <h1 class="mobile-title">{{ 'forgot.title' | translate }}</h1>
      <p class="mobile-subtitle">{{ 'forgot.caption' | translate }}</p>
    </div>
    <form [formGroup]="forgotPasswordFormGroup" class="forgot-password-form" autocomplete="off">
      <fieldset data-test="div-form-recuperacao" [disabled]="loading" class="fieldset">
        <h1 data-test="titulo-recuperacao" class="form-message">{{'forgot.title' | translate}}</h1>

        <p class="form-caption">{{'forgot.caption' | translate}}</p>

        <mat-form-field class="full-input-grid" appearance="outline">
          <mat-label>{{ 'signUp.email' | translate }}</mat-label>
          <input data-test="campo-email-recuperacao" type="email" matInput formControlName="email"
            placeholder="Ex: example@example.com">
          <mat-error
            *ngIf="form['email'].invalid && form['email'].touched && form['email'].dirty && !form['email'].hasError('emailExists')">{{message.errorMessage(form['email'])}}</mat-error>
          <mat-error *ngIf="form['email'].invalid && form['email'].touched && form['email'].dirty && form['email'].hasError('emailExists')">{{
            message.emailInUse(form['email'].value)}}</mat-error>
          <mat-icon matPrefix>email</mat-icon>
        </mat-form-field>

        <div class="actions-row">
          <app-auth-secondary-action dataTest="link-voltar" route="/sign-in"
            [buttonLabel]="'forgotPassword.message' | translate"
            [captionLabel]="'forgotPassword.rememberCaption' | translate"
            [linkLabel]="'forgotPassword.rememberLink' | translate">
          </app-auth-secondary-action>
          <button data-test="btn-recuperar" class="button" mat-raised-button color="primary"
            (click)="resetPassword()">{{ 'forgotPassword.button' | translate }}</button>
        </div>
      </fieldset>
    </form>
  </div>
</div>